import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    // Redirect to appropriate login based on route
    const path = window.location.pathname;
    if (path.includes('/owner')) {
      return <Navigate to="/login/owner" replace />;
    } else if (path.includes('/restaurant')) {
      return <Navigate to="/login/restaurant" replace />;
    } else if (path.includes('/staff')) {
      return <Navigate to="/login/staff" replace />;
    }
    return <Navigate to="/" replace />;
  }

  // Check if user is owner
  const isOwner = user.is_owner === true || user.role === 'owner';
  const ownerTenantId = localStorage.getItem('ownerTenantId');
  
  // Owner can access owner routes
  if (window.location.pathname.startsWith('/owner/')) {
    if (!isOwner) {
      return (
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
            <p className="text-gray-600">Owner privileges required.</p>
          </div>
        </div>
      );
    }
    return children;
  }

  // For restaurant routes: owner needs ownerTenantId set to access
  if (window.location.pathname.startsWith('/restaurant/')) {
    if (isOwner && !ownerTenantId) {
      return (
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
            <p className="text-gray-600">Please select a tenant to access restaurant dashboard.</p>
          </div>
        </div>
      );
    }
    // Allow owner with ownerTenantId or restaurant_admin
    if (allowedRoles.length > 0 && !allowedRoles.includes(user.role) && !(isOwner && ownerTenantId)) {
      return (
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
            <p className="text-gray-600">You don't have permission to access this page.</p>
          </div>
        </div>
      );
    }
    return children;
  }

  // For staff routes: check role
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role) && !isOwner) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return children;
};

export default PrivateRoute;




